function FacebookIcon() {
  return (
    <svg fill="none" height="20" width="20" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" fill="white" r="10" />
      <path
        d="M20 10.0016C20 4.47792 15.5228 0 10 0C4.4772 0 0 4.47792 0 10.0016C0 14.692 3.2288 18.6278 7.5844 19.7088V13.0581H5.5224V10.0016H7.5844V8.68459C7.5844 5.28045 9.1248 3.70259 12.4664 3.70259C13.1 3.70259 14.1932 3.82701 14.6404 3.95103V6.72148C14.4044 6.69667 13.9944 6.68427 13.4852 6.68427C11.8456 6.68427 11.212 7.30557 11.212 8.92063V10.0016H14.4784L13.9172 13.0581H11.212V19.93C16.1628 19.3319 20 15.1152 20 10.0016Z"
        fill="#0866FF"
      />
    </svg>
  );
}

export default FacebookIcon;
